/**
 * Calculates the duration of time in seconds during which a phase has no product.
 * The duration is determined based on the phase type:
 * - 'running': Returns 0 as there is no no-product duration.
 * - 'changeover', 'stopped': Returns the phase's duration.
 * - 'in_downtime': Returns the phase's duration plus any additional downtime delay.
 * @param {Object} phase - The phase object containing duration and phase type.
 * @param {string} phase.phase - The type of phase (e.g., 'running', 'changeover', 'stopped', 'in_downtime').
 * @param {number} phase.duration_s - The duration of the phase in seconds.
 * @param {number} [phase.max_downtime_delay=0] - Optional additional downtime delay for 'in_downtime' phases.
 * @returns {number} The duration in seconds during which the phase has no product.
 */
function calcNoProductDuration(phase) {
    switch (phase.phase) {
        case 'running':
            return 0;
        case 'changeover':
            return phase.duration_s;
        case 'stopped':
            return phase.duration_s;
        case 'in_downtime':
            return phase.duration_s + phase.max_downtime_delay;
    }
}

export { calcNoProductDuration };
